import { isPlatformBrowser } from '@angular/common';
import { Component, Input, inject, OnChanges, PLATFORM_ID } from '@angular/core';

@Component({
	selector: 'app-splash-screen',
	standalone: true,
	template: '',
})
export class SplashScreenComponent implements OnChanges {
	@Input() visible = true;

	private platformId = inject(PLATFORM_ID);

	ngOnChanges(): void {
		if (!isPlatformBrowser(this.platformId)) return;

		const splash = document.getElementById('app-splash');
		if (!splash) return;

		if (!this.visible) {
			splash.classList.add('fade-out');
			setTimeout(() => splash.remove(), 500);
		}
	}
}
